import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
export default function NewsItem({
	id,
	date,
	title,
	descriptionShort,
	image,
	imageAlt,
	url,
	isFocussed
}){
	const tagFocussed = useRef(false);

	useEffect(() => {
		if (tagFocussed.current.dataset.isFocussed === '1') {
			tagFocussed.current.focus();
		}
	}, []);

	return (
		<div class="news-filter-newsitem-wrapper" id={`newsitem-${id}`}>
			{image ? <div class="image-wrapper">
				<img src={image} alt={imageAlt} />
			</div> : ''}
			<div class="content-wrapper">
				<span class="date">{date}</span>
				<h3>{title}</h3>
				<p>{descriptionShort}</p>
				<a href={url} class={'link-local'} data-is-focussed={isFocussed ? '1' : 0} target={'_self'} ref={tagFocussed}>{'Lees meer'}</a>
			</div>
		</div>
	);
}
